export default __webpack_public_path__ + "static/media/cardbacken.0b1013be.png";